import React from 'react'

import { TRouteOverrides } from 'helpers/applyRouteOverrides'

import { SubscriptionDetails } from 'modules/unsubscribe/pages'

import { PageId } from 'page-constants'

import { FlowScope } from './components/FlowScope'
import { FlowCancelConfirmation } from './pages/FlowCancelConfirmation'
import { FlowCanceledPlan } from './pages/FlowCanceledPlan'
import { FlowContinuedPlan } from './pages/FlowContinuedPlan'
import { FlowDiscountOffer } from './pages/FlowDiscountOffer'
import { FlowPauseSubscription } from './pages/FlowPauseSubscription'
import { FlowReasons } from './pages/FlowReasons'
import { FlowTechnicalIssues } from './pages/FlowTechnicalIssues'

export const RETENTION_FLOW_V2_ROUTES: TRouteOverrides = {
  [PageId.SUBSCRIPTION_DETAILS]: (
    <FlowScope>
      <SubscriptionDetails />
    </FlowScope>
  ),
  [PageId.REASONS]: <FlowReasons />,
  [PageId.TECHNICAL_ISSUES]: <FlowTechnicalIssues />,
  [PageId.PAUSE_SUBSCRIPTION]: <FlowPauseSubscription />,
  [PageId.DISCOUNT_OFFER]: <FlowDiscountOffer />,
  [PageId.CONTINUED_SUBSCRIPTION]: <FlowContinuedPlan />,
  [PageId.CANCELED_SUBSCRIPTION]: <FlowCanceledPlan />,
}

export const FEMI_RETENTION_FLOW_V2_ROUTES: TRouteOverrides = {
  ...RETENTION_FLOW_V2_ROUTES,
  [PageId.CANCEL_CONFIRMATION]: <FlowCancelConfirmation />,
}
